// removed by extract-text-webpack-plugin
module.exports = {"heroContainer":"_1YlYwphvCvbU_VjNHuR8Iu","title":"_23Uzp0bgZcHOiC0FmMcskj","text":"_3bJPDrLm7ztj6PQLqFnPS4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/not-found/NotFound.css
// module id = 244
// module chunks = 0